import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

const getMember = async (options: Options = {}): Promise<SelfServiceAPI.GetMember.Response> => {
  try {
    const { data } = await api.get('/member');
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: 'GET /member',
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getMember;
